import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Building2 } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Für Eigentümer', href: '/fuer-eigentuemer' },
    { name: 'Für Investoren', href: '/fuer-investoren' },
    { name: 'Tools', href: '/tools' },
    { name: 'Verkaufsprozess', href: '/ablauf' },
    { name: 'Über uns', href: '/ueber-uns' },
    { name: 'Kontakt', href: '/kontakt' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white/95 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md"
              style={{
                background: 'linear-gradient(135deg, #0F2744 0%, #2563A0 100%)'
              }}
            >
              <Building2 className="h-7 w-7 text-white" />
            </div>
            <div>
              <div className="text-2xl font-bold" style={{ color: 'var(--navy-900)' }}>
                RetailInvest
              </div>
              <div className="text-xs font-medium" style={{ color: 'var(--gold-600)' }}>
                by Heinrichs Immobilien
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                data-testid={`nav-link-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive(item.href)
                    ? 'text-white shadow-md'
                    : 'hover:bg-gray-100'
                }`}
                style={{
                  backgroundColor: isActive(item.href) ? 'var(--navy-600)' : 'transparent',
                  color: isActive(item.href) ? 'white' : 'var(--gray-700)',
                }}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to="/tools/marktpreis">
              <Button
                data-testid="navbar-cta-button"
                className="btn-gold-gradient text-white border-0 font-semibold shadow-md hover:shadow-lg"
              >
                Marktwert berechnen
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset"
            style={{ focusRingColor: 'var(--navy-500)' }}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden border-t border-gray-200" data-testid="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-lg text-base font-medium ${
                  isActive(item.href) ? 'text-white shadow-sm' : 'hover:bg-gray-100'
                }`}
                style={{
                  backgroundColor: isActive(item.href) ? 'var(--navy-600)' : 'transparent',
                  color: isActive(item.href) ? 'white' : 'var(--gray-700)',
                }}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/ersteinschaetzung" onClick={() => setIsOpen(false)}>
              <Button
                className="w-full mt-2 btn-gold-gradient text-white border-0 font-semibold"
              >
                Handelsfläche verkaufen
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
